import React from 'react';
import {UpdateCustomerDataPopup} from "../../Customers/components/customers-table/UpdateCustomerDataPopup";


export function UpdateCustomerDataColumnFormatter(cellContent) {
  return <UpdateCustomerDataPopup {...cellContent}/>
}
